import { useState, useEffect } from 'react';

export const getWindowDimensions = () => {
    let width;
    let height;
    if (typeof window !== 'undefined') {
        const { innerWidth, innerHeight } = window;
        width = innerWidth;
        height = innerHeight;
    }
    return {
        width,
        height,
    };
};

export const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return windowDimensions;
};
